import { render, staticRenderFns } from "./GuvTable.vue?vue&type=template&id=48431e1e&scoped=true&"
import script from "./GuvTable.vue?vue&type=script&lang=ts&"
export * from "./GuvTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48431e1e",
  null
  
)

export default component.exports